import React, { useEffect, useState, useRef } from 'react';
import { Helmet } from 'react-helmet';
import { FiLoader, FiDownload } from "react-icons/fi";
import { FaLinkSlash } from "react-icons/fa6";
import { MdOutlineReceipt } from "react-icons/md";
import { FaCheckCircle } from "react-icons/fa";
import full from './full_logo.png';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const baseURL = process.env.REACT_APP_BASE_URL;
export const config = {
  Accept: 'application/json',
  headers: {
    // Authorization: `Bearer ${token}`,
    'Cache-Control': 'no-cache',
    Pragma: 'no-cache',
    Expires: '0',
  },
};
const Gravity = () => {
  const { id, cid } = useParams();
  const [amount, setAmount] = useState();
  const [product, setProduct] = useState('');
  const [loading, setLoading] = useState(true);
  const [paymentLoading, setPaymentLoading] = useState(false);
  const [companyName, setCompanyName] = useState('');
  const [companyLogo, setCompanyLogo] = useState('');
  const [loginId, setLoginId] = useState('');
  const [clientKey, setClientKey] = useState('');
  const [companyId, setCompanyId] = useState('');
  const [successUrl, setSuccessUrl] = useState('');
  const [token, setToken] = useState('');
  const [externalTransactionId, setExternalTransactionId] = useState('');
  const [Surcharge, setSurcharge] = useState(false);
  const [products, setProducts] = useState([]);
  const [userName, setUserName] = useState('');
  const [productEnabled, setProductEnabled] = useState(false);
  const [taxEnabled, setTaxEnabled] = useState(false);
  const [discountEnabled, setDiscountEnabled] = useState(false);
  const [TotalAmount, setTotalAmount] = useState(0);
  const [AddProductPrice, setAddProductPrice] = useState(0);
  const [AddProductDiscount, setAddProductDiscount] = useState(0);
  const [AddProductTax, setAddProductTax] = useState(0);
  const [address, setAddress] = useState([]);
  const [isPaid, setIsPaid] = useState(false);
  const [typeOfPayment, setTypeOfPayment] = useState('');
  const [isExpired, setisExpired] = useState(false);
  const [gravityWholeData, setGravityWholeData] = useState([]);
  const [emergepayLoaded, setEmergepayLoaded] = useState(false);
  const [scriptError, setScriptError] = useState(false);
  const [transactionResponse, setTransactionResponse] = useState(null);
  const [payType, setPayType] = useState('cc');
  const pendingApprovalRef = useRef(null);

  useEffect(() => {
    handleGetPaymentGravity();
    handleGetPaymentGravityToken();
  }, []);

  // Load EmergePay script with multiple fallbacks
  const loadEmergepayScript = (callback) => {
    const script = document.createElement('script');
    script.src = "https://assets.emergepay.chargeitpro.com/cip-hosted-modal.js";
    script.onload = callback;
    script.onerror = () => {
      tryAlternativeScript(callback);
    };
    document.body.appendChild(script);
  };

  const tryAlternativeScript = (callback) => {
    const script = document.createElement('script');
    script.src = "https://assets.emergepay.chargeitpro.com/emergepay-modal.js";
    script.onload = callback;
    script.onerror = () => {
      tryThirdScript(callback);
    };
    document.body.appendChild(script);
  };

  const tryThirdScript = (callback) => {
    const script = document.createElement('script');
    script.src = "https://assets.emergepay.chargeitpro.com/js/modal.js";
    script.onload = callback;
    script.onerror = () => {
      tryProductionScript(callback);
    };
    document.body.appendChild(script);
  };

  const tryProductionScript = (callback) => {
    const script = document.createElement('script');
    script.src = "https://assets.emergepay.chargeitpro.com/cip-hosted-modal.js";
    script.onload = callback;
    script.onerror = () => {
      tryFinalAlternatives(callback);
    };
    document.body.appendChild(script);
  };

  const tryFinalAlternatives = (callback) => {
    const alternatives = [
      "https://cdn.emergepay.com/modal.js",
      "https://js.emergepay.com/modal.js",
      "https://assets.emergepay.chargeitpro.com/scripts/emergepay.js",
      "https://demo.emergepay.gravitypayments.com/assets/emergepay-modal.js"
    ];

    let currentIndex = 0;

    function tryNext() {
      if (currentIndex >= alternatives.length) {
        setScriptError(true);
        return;
      }

      const script = document.createElement('script');
      script.src = alternatives[currentIndex];
      
      script.onload = () => {
        callback();
      };
      
      script.onerror = () => {
        currentIndex++;
        tryNext();
      };
      
      document.body.appendChild(script);
    }

    tryNext();
  };

  // Initialize EmergePay script when token is available
  useEffect(() => {
    if (token && !emergepayLoaded) {
      loadEmergepayScript(() => {
        setEmergepayLoaded(true);
        setScriptError(false);
      });
    }
  }, [token, emergepayLoaded]);

  // Handle payment modal launch
  const handlePaymentModal = () => {
    if (!token) {
      alert("Transaction token not available. Please try again.");
      return;
    }

    if (!emergepayLoaded) {
      alert("Payment system not loaded. Please try again.");
      return;
    }

    setPaymentLoading(true);

    const config = { transactionToken: token };
    
    // Find the payment object
    let paymentObj = null;
    let objName = '';
    
    if (typeof window.emergepay !== 'undefined') {
      paymentObj = window.emergepay;
      objName = 'emergepay';
    } else if (typeof window.EmergePay !== 'undefined') {
      paymentObj = window.EmergePay;
      objName = 'EmergePay';
    } else if (typeof window.EMERGEPAY !== 'undefined') {
      paymentObj = window.EMERGEPAY;
      objName = 'EMERGEPAY';
    } else if (typeof window.CIP !== 'undefined') {
      paymentObj = window.CIP;
      objName = 'CIP';
    } else if (typeof window.GravityPayments !== 'undefined') {
      paymentObj = window.GravityPayments;
      objName = 'GravityPayments';
    } else if (typeof window.GravityModal !== 'undefined') {
      paymentObj = window.GravityModal;
      objName = 'GravityModal';
    }
    
    if (!paymentObj) {
      alert("Payment system not found. Please contact support.");
      console.error("No payment object found. Check the debug output above.");
      setPaymentLoading(false);
      return;
    }
    
    try {
      paymentObj.open(config);
      // Reset loading state after attempting to open modal
      setTimeout(() => setPaymentLoading(false), 1000);
    } catch (error) {
      console.error("Error starting transaction:", error);
      alert("Error starting transaction: " + error.message);
      setPaymentLoading(false);
    }
  };

  const handleGetPaymentGravity = async () => {
    const response = await axios.get(`${baseURL}/payment/gravity/get-payment-data/${id}`, config);
    if (response.data.status === 'success') {
      const data = response.data.data;
      const body = data?.body || {};
      const payload = data?.payload || null;
      const settings = data?.settings || {};

      // After payment success, body becomes transactionResponse and order details move to payload
      const isTxnBody = Boolean(
        body?.maskedAccount
        || body?.amountProcessed
        || body?.uniqueTransId
        || body?.resultStatus
        || body?.approvalNumberResult
      );
      const orderData = payload || (!isTxnBody ? body : {}) || {};
      const txnData = isTxnBody
        ? body
        : (data?.transactionResponse || body?.transactionResponse || data?.approvalData || null);

      setGravityWholeData(data);
      setAmount(data.amount ?? orderData.amount ?? txnData?.amountProcessed ?? txnData?.amount);
      setProduct(data.product || orderData.product || '');
      setCompanyLogo(data?.company_logo);
      setCompanyName(data.company_name);
      setLoginId(data.name);
      setClientKey(data.token);
      setCompanyId(data.company_id);
      setSuccessUrl(data?.success_url);
      setSurcharge(Boolean(data?.surcharge ?? settings?.is_surcharge_enabled));

      const productsList = Array.isArray(orderData?.products) ? orderData.products : [];
      setProducts(productsList);
      setUserName(data?.name || orderData?.name || txnData?.billingName || '');
      setDiscountEnabled(Boolean(settings?.is_discount_enabled));
      setTaxEnabled(Boolean(settings?.is_tax_enabled));
      setProductEnabled(Boolean(settings?.bill_to_name) || productsList.length > 0);
      setAddress(data?.company_address);
      setIsPaid(data?.payment_status === 'paid' || data?.status === 'successful');
      setTypeOfPayment(data?.type || orderData?.type || '');
      setisExpired(Boolean(data?.is_expire));

      const nextPayType = String(orderData?.pay_type || data?.pay_type || settings?.pay_type || 'cc').toLowerCase();
      setPayType(['cc', 'ach', 'cc-ach'].includes(nextPayType) ? nextPayType : 'cc');

      // Prefer API breakdown from payload/order when provided
      if (orderData?.subtotal != null) setAddProductPrice(Number(orderData.subtotal).toFixed(2));
      if (orderData?.discount_amount != null) setAddProductDiscount(Number(orderData.discount_amount).toFixed(2));
      if (orderData?.tax_amount != null) setAddProductTax(Number(orderData.tax_amount).toFixed(2));
      if (orderData?.amount != null || data?.amount != null) {
        setTotalAmount(Number(orderData?.amount ?? data.amount).toFixed(2));
      }

      if (txnData?.maskedAccount || txnData?.amountProcessed || txnData?.uniqueTransId) {
        setTransactionResponse(txnData);
      }
    }
  };
  useEffect(() => {
    let totalPrice = 0;
    let totalDiscount = 0;
    let Totaltax = 0;
    if (productEnabled === true && products != undefined) {
      for (const product1 of products) {
        const productTotalPrice = product1.price * product1.quantity;
        totalPrice += productTotalPrice;
        const discountValue = Number(product1.discount) || 0;
        const isUsdDiscount = String(product1.discountType || '').toUpperCase() === 'USD';
        const productTotalDiscount = isUsdDiscount
          ? discountValue
          : (productTotalPrice * discountValue) / 100;
        totalDiscount += productTotalDiscount;
        const productTotalTAX = ((productTotalPrice - productTotalDiscount) * product1.tax) / 100;
        Totaltax += productTotalTAX;
      }
      setAddProductPrice(totalPrice.toFixed(2));
      setAddProductDiscount(totalDiscount.toFixed(2));
      setAddProductTax(Totaltax.toFixed(2));
      setTotalAmount((totalPrice - totalDiscount + Totaltax).toFixed(2));
    }
  }, [loading, amount, products, productEnabled]);

  const amountAfterDiscount = productEnabled && products?.length
    ? Number(TotalAmount) || Number(amount) || 0
    : Number(amount) || 0;
  const paidAmount = Number(
    transactionResponse?.amountProcessed
    || transactionResponse?.amount
    || 0
  );
  const payableTotal = isPaid && paidAmount > 0
    ? paidAmount.toFixed(2)
    : amountAfterDiscount.toFixed(2);
  const displaySubtotal = (productEnabled && products?.length)
    ? (AddProductPrice || amountAfterDiscount.toFixed(2))
    : amountAfterDiscount.toFixed(2);

  const handleInvoice = async () => {
    const invoiceData = gravityWholeData;
    if (!invoiceData) return;

    const body = invoiceData?.body || {};
    const payload = invoiceData?.payload || {};
    const isTxnBody = Boolean(
      body?.maskedAccount || body?.amountProcessed || body?.uniqueTransId || body?.resultStatus
    );
    const orderData = payload || (!isTxnBody ? body : {}) || {};
    const txn = transactionResponse
      || (isTxnBody ? body : null)
      || invoiceData?.transactionResponse
      || {};

    const invoiceNumber =
      (invoiceData.self_invoice_id && String(invoiceData.self_invoice_id).trim())
        ? String(invoiceData.self_invoice_id).trim()
        : (
          (orderData?.inovice_id && String(orderData.inovice_id).trim())
          || (orderData?.invoice_id && String(orderData.invoice_id).trim())
          || orderData?.invoiceNumber
          || invoiceData?.invoice_number
          || invoiceData?.id
          || id
        );

    const totalPaid = Number(txn.amountProcessed || txn.amount || payableTotal || 0).toFixed(2);
    const paymentDateSource = txn.createdOn
      ? new Date(txn.createdOn)
      : invoiceData?.created_at
        ? new Date(invoiceData.created_at)
        : new Date();
    const paymentDate = paymentDateSource.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });

    const street = [address?.street_address, address?.apartment_or_suite]
      .filter((p) => p && String(p).trim())
      .join(' ');
    const cityState = [address?.city, address?.state_or_province]
      .filter((p) => p && String(p).trim())
      .join(', ');
    const cityLine = [cityState, address?.zip].filter((p) => p && String(p).trim()).join(' ');

    const cardTypeMap = { VS: 'Visa', MC: 'Mastercard', AX: 'Amex', DS: 'Discover' };
    const cardBrand = cardTypeMap[txn.accountCardType] || txn.accountCardType || 'Card';
    const last4 = (txn.maskedAccount || '').replace(/\*/g, '').slice(-4);
    const paymentMethodLabel = last4 ? `${cardBrand} •••• ${last4}` : cardBrand;

    const productList = Array.isArray(orderData?.products) && orderData.products.length
      ? orderData.products
      : (Array.isArray(products) ? products : []);
    let itemsHtml = '';
    let subtotal = Number(orderData?.subtotal) || 0;
    let totalDiscount = Number(orderData?.discount_amount) || 0;
    let totalTax = Number(orderData?.tax_amount) || 0;

    if (productList.length > 0) {
      if (!subtotal) {
        subtotal = 0;
        totalDiscount = 0;
        totalTax = 0;
        productList.forEach((item) => {
          const lineTotal = Number(item.price || 0) * Number(item.quantity || 1);
          subtotal += lineTotal;
          const discountValue = Number(item.discount) || 0;
          const isUsdDiscount = String(item.discountType || '').toUpperCase() === 'USD';
          const lineDiscount = isUsdDiscount ? discountValue : (lineTotal * discountValue) / 100;
          totalDiscount += lineDiscount;
          totalTax += ((lineTotal - lineDiscount) * (Number(item.tax) || 0)) / 100;
        });
      }
      itemsHtml = productList.map((item) => {
        const lineTotal = Number(item.price || 0) * Number(item.quantity || 1);
        return `
          <tr>
            <td class="px-6 py-4 text-sm text-gray-900">
              <div class="font-medium">${item.name || item.product || product || 'Item'}</div>
              <div class="text-gray-500 text-xs">${item.quantity || 1} × $${Number(item.price || 0).toFixed(2)}</div>
            </td>
            <td class="px-6 py-4 text-sm text-gray-900 text-right">$${lineTotal.toFixed(2)}</td>
          </tr>
        `;
      }).join('');
    } else {
      subtotal = Number(txn.amountProcessed || txn.amount || amount || 0);
      itemsHtml = `
        <tr>
          <td class="px-6 py-4 text-sm text-gray-900">
            <div class="font-medium">${product || orderData?.product || 'Payment'}</div>
          </td>
          <td class="px-6 py-4 text-sm text-gray-900 text-right">$${Number(subtotal).toFixed(2)}</td>
        </tr>
      `;
    }

    const billingName = txn.billingName || userName || invoiceData?.name || '—';
    const billingEmail = invoiceData?.email || '';
    const billingPhone = invoiceData?.phone || '';

    const invoiceHTML = `
      <!DOCTYPE html>
      <html lang="en">
      <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>Invoice - ${invoiceNumber}</title>
        <script src="https://cdn.tailwindcss.com"></script>
        <style>
          @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');
          body { font-family: 'Inter', sans-serif; }
          .invoice-header { background: linear-gradient(135deg, #3b82f6 0%, #7c3aed 100%); }
          .status-paid { background: linear-gradient(135deg, #059669 0%, #10b981 100%); }
          @media print {
            body { print-color-adjust: exact; -webkit-print-color-adjust: exact; }
            .no-print { display: none !important; }
          }
        </style>
      </head>
      <body class="bg-gray-50 p-6 md:p-8">
        <div class="max-w-3xl mx-auto bg-white shadow-2xl rounded-xl overflow-hidden">
          <div class="invoice-header text-white px-8 py-6">
            <div class="flex justify-between items-start gap-4">
              <div class="flex items-center space-x-4 min-w-0">
                ${companyLogo ? `<img src="${companyLogo}" alt="Company Logo" class="h-14 w-14 rounded-lg bg-white p-1.5 object-contain shrink-0">` : ''}
                <div class="min-w-0">
                  <h1 class="text-xl md:text-2xl font-bold truncate">${companyName || ''}</h1>
                  ${street ? `<p class="text-blue-100 text-sm">${street}</p>` : ''}
                  ${cityLine ? `<p class="text-blue-100 text-sm">${cityLine}</p>` : ''}
                </div>
              </div>
              <div class="text-right shrink-0">
                <h2 class="text-2xl md:text-3xl font-bold mb-2 tracking-wide">INVOICE</h2>
                <div class="status-paid text-white px-4 py-1.5 rounded-lg inline-block text-sm">
                  <span class="font-semibold">PAID</span>
                </div>
              </div>
            </div>
          </div>

          <div class="px-8 py-6">
            <div style="display:flex;gap:24px;margin-bottom:32px;align-items:stretch;">
              <div style="flex:1;min-width:0;">
                <h3 class="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-2">Bill To</h3>
                <div class="bg-gray-50 p-4 rounded-lg space-y-1" style="height:100%;">
                  <p class="font-semibold text-gray-900">${billingName}</p>
                  ${billingEmail ? `<p class="text-sm text-gray-600">${billingEmail}</p>` : ''}
                  ${billingPhone ? `<p class="text-sm text-gray-600">${billingPhone}</p>` : ''}
                </div>
              </div>
              <div style="flex:1;min-width:0;">
                <h3 class="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-2">Invoice Details</h3>
                <div class="bg-gray-50 p-4 rounded-lg space-y-2 text-sm" style="height:100%;">
                  <div class="flex justify-between gap-3">
                    <span class="text-gray-500">Invoice #</span>
                    <span class="font-medium text-gray-900 text-right break-all">${invoiceNumber}</span>
                  </div>
                  <div class="flex justify-between gap-3">
                    <span class="text-gray-500">Payment Date</span>
                    <span class="font-medium text-gray-900">${paymentDate}</span>
                  </div>
                  <div class="flex justify-between gap-3">
                    <span class="text-gray-500">Payment Method</span>
                    <span class="font-medium text-gray-900">${paymentMethodLabel}</span>
                  </div>
                  ${txn.approvalNumberResult ? `
                  <div class="flex justify-between gap-3">
                    <span class="text-gray-500">Approval</span>
                    <span class="font-medium text-gray-900">${txn.approvalNumberResult}</span>
                  </div>` : ''}
                </div>
              </div>
            </div>

            <div class="mb-8">
              <h3 class="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-3">Items</h3>
              <div class="border border-gray-200 rounded-lg overflow-hidden">
                <table class="w-full">
                  <thead class="bg-gray-50">
                    <tr>
                      <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Description</th>
                      <th class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Amount</th>
                    </tr>
                  </thead>
                  <tbody class="divide-y divide-gray-100">
                    ${itemsHtml}
                  </tbody>
                </table>
              </div>
            </div>

            <div class="flex justify-end">
              <div class="w-full max-w-sm">
                <div class="bg-gray-50 p-5 rounded-lg space-y-2 text-sm">
                  <div class="flex justify-between">
                    <span class="text-gray-600">Subtotal</span>
                    <span class="font-medium text-gray-900">$${subtotal.toFixed(2)}</span>
                  </div>
                  ${totalDiscount > 0 ? `
                  <div class="flex justify-between">
                    <span class="text-gray-600">Discount</span>
                    <span class="font-medium text-red-500">-$${totalDiscount.toFixed(2)}</span>
                  </div>` : ''}
                  ${totalTax > 0 ? `
                  <div class="flex justify-between">
                    <span class="text-gray-600">Tax</span>
                    <span class="font-medium text-gray-900">$${totalTax.toFixed(2)}</span>
                  </div>` : ''}
                  <div class="flex justify-between items-center pt-3 border-t border-gray-200">
                    <span class="text-base font-semibold text-gray-800">Total Amount</span>
                    <span class="text-xl font-bold text-gray-900">$${totalPaid}</span>
                  </div>
                  <div class="flex justify-between items-center">
                    <span class="text-base font-semibold text-green-600">Amount Paid</span>
                    <span class="text-xl font-bold text-green-600">$${totalPaid}</span>
                  </div>
                  <div class="flex justify-between items-center pt-2 border-t border-gray-200">
                    <span class="text-base font-semibold text-gray-800">Balance Due</span>
                    <span class="text-xl font-bold text-gray-800">$0.00</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="mt-8 pt-6 border-t border-gray-200 text-center text-gray-500">
              <p class="text-sm">Thank you for your business!</p>
              <div class="flex justify-center items-center mt-4">
                <span class="text-xs">Powered by</span>
                <img src="https://s3.us-east-2.amazonaws.com/sc-prod-embedded.salescaptain.com/resources/2023-07-22/sales_captain_1690015901642.png" class="h-4 ml-2" alt="SalesCaptain">
                <span class="ml-1 font-semibold text-xs">SalesCaptain</span>
              </div>
            </div>
          </div>
        </div>
        <script>
          window.onload = function() {
            setTimeout(function() { window.print(); }, 300);
          };
        </script>
      </body>
      </html>
    `;

    const iframe = document.createElement('iframe');
    iframe.style.position = 'fixed';
    iframe.style.right = '0';
    iframe.style.bottom = '0';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = '0';
    document.body.appendChild(iframe);

    const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
    iframeDoc.open();
    iframeDoc.write(invoiceHTML);
    iframeDoc.close();

    const cleanup = () => {
      setTimeout(() => {
        if (iframe.parentNode) document.body.removeChild(iframe);
      }, 1500);
    };

    iframe.onload = () => {
      setTimeout(() => {
        try {
          iframe.contentWindow.focus();
          iframe.contentWindow.print();
        } catch (e) {
          console.error('Invoice print failed:', e);
        }
        cleanup();
      }, 400);
    };
  };
  const handleGetPaymentGravityToken = async () => {
    const response = await axios.post(`${baseURL}/payment/gravity/start-transaction/${id}`, config);
    if (response.data.status === 'success') {
      setToken(response?.data?.data?.transactionToken);
      setExternalTransactionId(response?.data?.data?.externalTransactionId);
      setLoading(false);
    }
  };
  const handleupdategravitypayment = async (body) => {
    const res = await axios.put(`${baseURL}/payment/gravity/update-gravity-payment/${id}`, body, config);
    if (res.data.status === 'success') {
      window.location.reload();
    }
  };
  
  useEffect(() => {
    const parseEventData = (raw) => {
      if (!raw) return null;
      if (typeof raw === 'string') {
        try {
          return JSON.parse(raw);
        } catch (e) {
          return null;
        }
      }
      if (typeof raw === 'object') return raw;
      return null;
    };

    const extractApprovalData = (payload) => {
      if (!payload) return null;
      let inner = payload.data;
      if (typeof inner === 'string') {
        try {
          inner = JSON.parse(inner);
        } catch (e) {
          inner = null;
        }
      }
      return (
        inner?.approvalData
        || payload?.approvalData
        || payload?.transactionResponse
        || inner?.transactionResponse
        || null
      );
    };

    const handleMessage = async (event) => {
      if (!event?.data) return;

      const payload = parseEventData(event.data);
      if (!payload) return;

      // Modal closed — update payment + reload if approved
      const isCloseModal = (
        payload.action === 2
        || payload.data === 'close modal!'
        || (typeof payload.data === 'string' && payload.data.toLowerCase().includes('close modal'))
      );

      if (isCloseModal) {
        setPaymentLoading(false);
        if (pendingApprovalRef.current) {
          const formdata = {
            data: pendingApprovalRef.current,
            event_status: 'SUCCESS',
            transactionResponse: pendingApprovalRef.current,
          };
          try {
            await handleupdategravitypayment(formdata);
          } catch (e) {
            console.error('Failed to update gravity payment:', e);
            window.location.reload();
          }
        }
        return;
      }

      const txnResponse = extractApprovalData(payload);
      const isApproved = txnResponse && (
        String(txnResponse.resultStatus).toLowerCase() === 'true'
        || String(txnResponse.resultMessage || '').toLowerCase() === 'approved'
      );

      if (isApproved) {
        pendingApprovalRef.current = txnResponse;
        setTransactionResponse(txnResponse);
        setPaymentLoading(false);
        setIsPaid(true);
        return;
      }

      if (
        payload.type === 'EMERGEPAY_ERROR'
        || payload.type === 'GRAVITY_PAYMENT_ERROR'
        || payload.event === 'payment_error'
        || (txnResponse && String(txnResponse.resultStatus).toLowerCase() === 'false')
      ) {
        pendingApprovalRef.current = null;
        setPaymentLoading(false);
        alert(txnResponse?.resultMessage || 'Payment failed. Please try again.');
      }
    };

    window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [token, id]);
  

  if (loading) {
    return (
      <div className="w-full h-[100vh] items-center justify-between flex flex-col">
        <FiLoader size={50} className="animate-spin mt-[47vh]" />
        <div className='bg-[#fff] flex justify-center items-center relative text-[20px] pb-2 h-[1.5rem] w-full rounded-b-[8px] mb-[5vh]'>
          {/* <a href="https://salescaptain.com/" target="_blank" className='underline text-blue-600 font-semibold' rel="noreferrer">
          Visit our website
        </a> */}

          <span className="text-[#535355]"> Powered by</span>
          <div
            className='flex items-center ml-1 cursor-pointer'
            onClick={() => window.open('https://www.salescaptain.com')}
          >
            <img src={localStorage.getItem('h_url') ?? 'https://s3.us-east-2.amazonaws.com/sc-prod-embedded.salescaptain.com/resources/2023-07-22/sales_captain_1690015901642.png'} className=" h-[18px]" alt="" />
            <span
              className="font-semibold ml-1"
            >
              {localStorage.getItem('h_name') ?? 'SalesCaptain'}
            </span>
          </div>
        </div>

      </div>
    );
  }

  if (isExpired === true) {
    return (
      <div className="w-full h-full items-center justify-center flex flex-col">
        <FaLinkSlash className="text-[80px] mb-[20px]" />
        <span className="text-[30px] medium">
          Link Expired
        </span>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50 flex flex-col items-center justify-center p-4" id="payment-receipt">
      {/* Modern Header */}
      <div className="w-full max-w-md mb-6">
        <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-6 shadow-lg border border-white/20">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              {companyLogo && (
                <div className="w-16 h-16 rounded-xl bg-gradient-to-br from-blue-500 to-purple-600 p-0.5">
                  <div className="w-full h-full rounded-xl bg-white p-2">
                    <img className="w-full h-full object-contain" src={companyLogo} alt="Company Logo" />
                  </div>
                </div>
              )}
              <div className="flex-1">
                <h1 className="text-xl font-bold text-gray-800 leading-tight">{companyName}</h1>
                <p className="text-sm text-gray-500 leading-tight">
                  {address?.street_address} {address?.apartment_or_suite}
                </p>
                <p className="text-sm text-gray-500">
                  {address?.city}, {address?.state_or_province} {address?.zip}
                </p>
              </div>
            </div>
            
            {/* Download Invoice Button - Only show when paid */}
            {isPaid && (
              <div className="ml-4">
                <button 
                  onClick={handleInvoice} 
                  className="group flex items-center space-x-2 bg-gradient-to-r from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700 text-white px-4 py-2 rounded-xl shadow-lg transition-all duration-200 transform hover:scale-105"
                >
                  <FiDownload className="w-4 h-4 group-hover:animate-bounce" />
                  <span className="text-sm font-medium">Invoice</span>
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Modern Payment Card */}
      <div className="w-full max-w-md">
        <div className="bg-white/90 backdrop-blur-sm rounded-3xl shadow-2xl border border-white/20 overflow-hidden">
          {/* Card Header */}
          <div className="bg-slate-50 p-6">
            <div className="flex items-center justify-between">
              <div>
                <h2 className="text-lg font-semibold text-slate-800">Payment Details</h2>
                {isPaid && (
                  <p className="text-slate-500 text-sm">Transaction #{gravityWholeData?.transaction_id}</p>
                )}
              </div>
              {isPaid && (
                <div className="flex items-center space-x-2 bg-emerald-50 rounded-full px-3 py-1">
                  <FaCheckCircle className="w-4 h-4 text-emerald-500" />
                  <span className="text-sm font-medium text-emerald-500">Paid</span>
                </div>
              )}
            </div>
          </div>

          {/* Card Content */}
          <div className="p-6 ">
            {/* Bill To */}
            <div className="flex items-center justify-between py-3 border-b border-gray-100">
              <span className="text-gray-600 font-medium">Bill to:</span>
              <span className="text-gray-800 font-semibold">{userName}</span>
            </div>

            {/* Product Details */}
            {productEnabled === true && products?.length > 1 && (
              <div className="border-b border-gray-100 pb-4">
                <h3 className="text-gray-600 font-medium mb-3">Products:</h3>
                <div className="space-y-2 max-h-32 overflow-y-auto">
                  {products?.map((field, index) => (
                    <div key={index} className="flex items-center justify-between text-sm">
                      <span className="text-gray-600">
                        {field.quantity}× {field.name || field.product}
                      </span>
                      <span className="font-medium text-gray-800">
                        ${(Number(field.price) * Number(field.quantity || 1)).toFixed(2)}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Single Product or Service */}
            {(productEnabled === true && products?.length === 1) || !productEnabled && (
              <div className="text-center py-4 border-b border-gray-100">
                <div className="inline-flex items-center space-x-2 bg-gray-50 rounded-full px-4 py-2">
                  <MdOutlineReceipt className="w-4 h-4 text-gray-500" />
                  <span className="text-gray-700 font-medium">
                    {productEnabled ? (products[0]?.name || products[0]?.product) : product}
                  </span>
                </div>
              </div>
            )}

            {/* Amount Breakdown */}
            <div className="space-y-3">
              {/* Subtotal */}
              <div className="flex items-center justify-between">
                <span className="text-gray-600">Subtotal</span>
                <span className="font-medium text-gray-800">
                  ${productEnabled && products?.length ? AddProductPrice : displaySubtotal}
                </span>
              </div>

              {/* Discount */}
              {discountEnabled && productEnabled && products?.length > 0 && (
                <div className="flex items-center justify-between">
                  <span className="text-gray-600">Discount</span>
                  <span className="font-medium text-red-500">-${AddProductDiscount}</span>
                </div>
              )}

              {/* Tax */}
              {taxEnabled && productEnabled && products?.length > 0 && (
                <div className="flex items-center justify-between">
                  <span className="text-gray-600">Tax</span>
                  <span className="font-medium text-gray-800">${AddProductTax}</span>
                </div>
              )}

              {/* Total Amount */}
              <div className="flex items-center justify-between pt-3 border-t border-gray-200">
                <span className="text-lg font-semibold text-gray-800">
                  {isPaid ? 'Total Paid' : 'Total Amount Payable'}
                </span>
                <span className="text-xl font-bold text-gray-800">
                  ${payableTotal}
                </span>
              </div>

              {/* Balance Due */}
              {isPaid && (
                <div className="flex items-center justify-between">
                  <span className="text-gray-600">Balance Due</span>
                  <span className="font-bold text-green-600">$0.00</span>
                </div>
              )}
            </div>

            {/* Action Button */}
            <div className="pt-4">
              {isPaid ? (
                <div className="w-full bg-gradient-to-r from-green-500 to-emerald-500 text-white font-semibold py-4 text-center rounded-2xl">
                  <div className="flex items-center justify-center space-x-2">
                    <FaCheckCircle className="w-5 h-5" />
                    <span>Payment Completed</span>
                  </div>
                </div>
              ) : scriptError ? (
                <div className="w-full bg-gradient-to-r from-red-500 to-red-600 text-white font-semibold py-4 text-center rounded-2xl">
                  <div className="flex items-center justify-center space-x-2">
                    <span>❌ Payment system unavailable</span>
                  </div>
                </div>
              ) : !emergepayLoaded ? (
                <div className="w-full bg-gradient-to-r from-gray-400 to-gray-500 text-white font-semibold py-4 text-center rounded-2xl">
                  <div className="flex items-center justify-center space-x-2">
                    <FiLoader className="w-5 h-5 animate-spin" />
                    <span>Loading Payment System...</span>
                  </div>
                </div>
              ) : (
                <button
                  onClick={handlePaymentModal}
                  className="block w-full bg-gradient-to-r from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700 text-white font-semibold py-4 text-center rounded-2xl transition-all duration-200 transform hover:scale-105 shadow-lg disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
                  disabled={!emergepayLoaded || paymentLoading}
                >
                  {paymentLoading ? (
                    <div className="flex items-center justify-center space-x-2">
                      <FiLoader className="w-5 h-5 animate-spin" />
                      <span>Opening Payment...</span>
                    </div>
                  ) : (
                    'Pay Now'
                  )}
                </button>
              )}
              
              {/* Error message for script loading */}
              {scriptError && (
                <div className="mt-4 p-3 bg-red-50 border border-red-200 rounded-lg">
                  <p className="text-red-600 text-sm text-center">
                    Unable to load payment system. Please refresh the page or contact support.
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="mt-8 flex items-center space-x-2 text-gray-500">
        <span className="text-sm">Powered by</span>
        <img className="h-4" src={localStorage.getItem('h_url') ?? 'https://s3.us-east-2.amazonaws.com/sc-prod-embedded.salescaptain.com/resources/2023-07-22/sales_captain_1690015901642.png'} alt="SalesCaptain" />
        <span className="text-sm capitalize">{localStorage.getItem('h_name') ?? 'SalesCaptain'}</span>
      </div>
    </div>
  );
};

export default Gravity;
